import { Button as MaterialButton, ButtonProps as MaterialButtonProps, CircularProgress} from "@material-ui/core";

import classes from "./Button.module.scss";

export interface ButtonProps extends MaterialButtonProps {
  loading?: boolean;
  component?: string;
}

const Button = (props: ButtonProps) => (
  <MaterialButton
    type="button"
    variant="contained"
    {...props}
  >
    <div className={classes.wrap}>
      <div className={props.loading ? classes.hidden : ''}>
        {props.children}
      </div>
      {props.loading && (
        <div className={classes.loading}>
          <CircularProgress size={20} />
        </div>
      )}
    </div>
  </MaterialButton>
);

export default Button;